function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgTruck = function SvgTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.778 5.333c-.614 0-1.111.498-1.111 1.111V20.89c0 .614.497 1.111 1.11 1.111h1.486a3.889 3.889 0 107.03 0h7.414a3.889 3.889 0 107.03 0h1.485c.614 0 1.111-.497 1.111-1.111v-5.556c0-.294-.117-.577-.325-.785l-3.334-3.334a1.111 1.111 0 00-.785-.325h-3.334V6.444c0-.613-.497-1.11-1.11-1.11H3.777zM23.195 22h.054a1.667 1.667 0 11-.054 0zm.069-2.222h3.847v-3.984L24.43 13.11h-2.873v6.667H23.262zm-14.486 0H19.333V7.556H4.89v12.222H8.778zM7.11 23.667c0-.914.734-1.655 1.644-1.667H8.8a1.667 1.667 0 11-1.69 1.666z",
    fill: props.color
  }));
};

SvgTruck.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgTruck.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgTruck;